import { SERVICE_CENTERS } from "../shared/tagTypes";
import { baseApi } from "./base";

const serviceCenterApi = baseApi
    .enhanceEndpoints({
        addTagTypes: [SERVICE_CENTERS],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getServiceCenters: builder.query({
                query: (payload) => ({
                    url: payload.companyId ? `/serial-no/companies/${payload.companyId}/service-centers` : "/serial-no/service-centers",
                    params: {
                        businessTypeId: payload.businessTypeId
                    }
                }),
                providesTags: [SERVICE_CENTERS],
            }),
            getServiceCenter: builder.query({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-centers/${payload.id}`
                }),
                providesTags: [SERVICE_CENTERS],
            }),
            searchServiceCenters: builder.query({
                query: (payload) => ({
                    url: "/serial-no/service-centers/search",
                    params: {
                        ...(payload.businessTypeId && { businessTypeId: payload.businessTypeId }),
                        ...(payload.searchText && { searchText: payload.searchText })
                    }
                }),
                providesTags: [SERVICE_CENTERS],
            }),
            createServiceCenter: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-centers`,
                    method: "POST",
                    body: payload.body,
                }),
                invalidatesTags: [SERVICE_CENTERS],
            }),
            updateServiceCenter: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-centers/${payload.id}`,
                    method: "PUT",
                    body: payload.body,
                }),
                invalidatesTags: [SERVICE_CENTERS],
            }),
            deleteServiceCenter: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-centers/${payload.id}`,
                    method: "DELETE",
                }),
                invalidatesTags: [SERVICE_CENTERS],
            })
        }),

        overrideExisting: false,
    });

export const {
    useGetServiceCentersQuery,
    useLazyGetServiceCentersQuery,
    useSearchServiceCentersQuery,
    useLazySearchServiceCentersQuery,
    useGetServiceCenterQuery,
    useLazyGetServiceCenterQuery,
    useCreateServiceCenterMutation,
    useUpdateServiceCenterMutation,
    useDeleteServiceCenterMutation
} = serviceCenterApi;
